import {
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';

import IntegrationsForm from '@/client/components/learners/profile/forms/integrations/IntegrationsForm';
import NotificationPreferencesForm from '@/client/components/learners/profile/forms/account-settings/NotificationPreferencesForm';
import PasswordResetForm from '@/client/components/learners/profile/forms/account-settings/password-reset/PasswordResetForm';
import SolidButton from '@/client/components/shared/buttons/SolidButton';
import { useAuthStore } from '@/client/services/state/authStore';
import { useLearnerProfileStore } from '@/client/components/learners/profile/state/learnerProfileStore';
import { useTranslation } from 'react-i18next';

export default function LearnerProfileAccountSettingsFormModal() {
  const { t } = useTranslation();
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const { feature_flags: featureFlags } = company;
  const {
    disable_notification_preferences: disableNotificationPreferences,
    enable_microsoft_teams_meetings: enableMicrosoftTeamsMeetings,
    enable_google_meets: enableGoogleMeets,
  } = featureFlags;
  const { accountSettingsModalIsOpen, setAccountSettingsModalIsOpen } = useLearnerProfileStore();

  const onClose = () => setAccountSettingsModalIsOpen(false);

  const isNotificationPreferencesEnabled = !disableNotificationPreferences;

  const isIntegrationsEnabled = enableMicrosoftTeamsMeetings || enableGoogleMeets;

  return (
    <Modal size="3xl" isOpen={accountSettingsModalIsOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody paddingTop={10} paddingBottom={8} paddingX={8}>
          <Stack spacing={10}>
            <Text fontSize="28px" fontWeight={600} color="baseBlack">
              {t('learners.profile.accountSettings.title')}
            </Text>

            {isNotificationPreferencesEnabled && (
              <>
                <NotificationPreferencesForm />

                <Divider />
              </>
            )}

            <PasswordResetForm />

            {isIntegrationsEnabled && (
              <>
                <Divider />

                <IntegrationsForm />
              </>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter paddingY={6} paddingX={8} boxShadow="0 -4px 8px 0 rgba(0, 0, 0, 0.04)">
          <SolidButton onClick={onClose}>{t('learners.profile.accountSettings.done')}</SolidButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
